import { fetchApi } from '@/config/axiosSetting';
import { PatchCostQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCost/patchCostQuery.type';

export const patchCostFunction = (params: PatchCostQueryParamsType) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/costs/`,
    {
      parts_daghi: params?.data?.parts_daghi,
      parts_reduction: params?.data?.parts_reduction,
      parts_transportation: params?.data?.parts_transportation,
      parts_max_body_price: params?.data?.parts_max_body_price,
      vehicle_price: params?.data?.vehicle_price,
      parts_prev_reduction: params?.data?.parts_prev_reduction,
    },
    {
      params: {
        damaged_id: params.damaged_id,
        id: params.id,
      },
    },
  );
};
